<template>
    <div class="msgwrapper">
        <div class="title">
            <span>게임조아 쪽지</span>
            <span class="set">
                <img src="@/assets/imgs/icon/setting.png" >
                설정
            </span>
        </div>
        <div class="btn_group">
            <router-link to='/pop/message/receive' class="btn" :class="currentMode('message_receive')">
            <img src="@/assets/imgs/icon/message_receive.png" > 받은쪽지
            </router-link>
            <router-link to='/pop/message/send' class="btn" :class="currentMode('message_send')">
             <img src="@/assets/imgs/icon/message_send.png" > 보낸쪽지
            </router-link>
            <router-link to='/pop/message/Write' class="btn" :class="currentMode('message_write','message_write_nor')">
            <img src="@/assets/imgs/icon/message_write.png" > 쪽지쓰기
            </router-link>
            <router-link to='/pop/message/friends' class="btn" :class="currentMode('message_friends_list')">
             <img src="@/assets/imgs/icon/addressbook.png" > 친구목록
            </router-link>
        </div>
        <router-view/>
    </div>
</template>
<script>
export default {
    name:'message',
    methods:{
        currentMode(link, link2)
        {
            if(this.$route.name === link || this.$route.name === link2 )
            {
                return 'active'
            }else{
                return null
            }


        }
    }
}
</script>
<style lang="scss" scoped>
.msgwrapper{
    background:#fff;
    height:100vh;
}
.title{
    background:#3d008d;
    padding:10px 20px;
    color:white;
    font-size:14px;
    font-weight:bold;
    font-family:'malgun-gothic';
    display:flex;
    justify-content:space-between;
    .set{
        img{
            vertical-align:middle;
        }
        font-family:'dotum';
        font-weight:normal;
        font-size:12px;
    }
}
.btn_group{

    display:flex;
    justify-content:start;
    margin-bottom:10px;

    .btn{
        padding-left: 1rem;
        padding-right: 1rem;
        padding-top: .5rem;
        padding-bottom: .5rem;
        transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;
        transition-duration: .2s;
        transition-timing-function: cubic-bezier(.4,0,.2,1);
        text-decoration:none;
        background-color: #f8f8f8;;
        width:25%;
        text-align:center;
        border-bottom: 1px solid #dedddc;
        img{
            vertical-align: middle;
        }
    }
    .btn:hover{
        --transform-scale-x: 1.1;
        --transform-scale-y: 1.1;
        color: #e6fffa;
        background-color: #ccc;
        font-weight:Bold;
    }
    .active{
        --transform-scale-x: 1.1;
        --transform-scale-y: 1.1;
        color: #3d008d;
        background-color: #fff;
        font-weight:Bold;
        border-bottom-width: 0;
        border-right: 1px solid #dedddc;
        border-left: 1px solid #dedddc;
    }
}
</style>
